import Controller from "./loans.controller";
import template from "./loans.html";

const loans = {
  template,
  controller: Controller,
};

export default loans;



// WEBPACK FOOTER //
// ./src/pages/loans/loans.component.js